/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as R404Import } from './routes/404'
import { Route as SamsungSmartThingsRouteImport } from './routes/samsung.smart-things/route'
import { Route as SamsungSmartThingsguestRouteImport } from './routes/samsung.smart-things/(guest)/route'
import { Route as SamsungSmartThingsappRouteImport } from './routes/samsung.smart-things/(app)/route'
import { Route as SamsungSmartThingsappIndexImport } from './routes/samsung.smart-things/(app)/index'
import { Route as SamsungSmartThingsguestLoginIndexImport } from './routes/samsung.smart-things/(guest)/login/index'
import { Route as SamsungSmartThingsappMyConsultationsIndexImport } from './routes/samsung.smart-things/(app)/my-consultations/index'
import { Route as SamsungSmartThingsappAskAVetIndexImport } from './routes/samsung.smart-things/(app)/ask-a-vet/index'
import { Route as SamsungSmartThingstempLoginOauth2Import } from './routes/samsung.smart-things/(temp)/login/oauth2'
import { Route as SamsungSmartThingsappConsultationIdImport } from './routes/samsung.smart-things/(app)/consultation/$id'
import { Route as SamsungSmartThingsappAskAVetSubmittedImport } from './routes/samsung.smart-things/(app)/ask-a-vet/submitted'
import { Route as SamsungSmartThingsappAskAVetSelectPetImport } from './routes/samsung.smart-things/(app)/ask-a-vet/select-pet'
import { Route as SamsungSmartThingsappAskAVetMainConcernImport } from './routes/samsung.smart-things/(app)/ask-a-vet/main-concern'
import { Route as SamsungSmartThingsappAskAVetAttachmentImport } from './routes/samsung.smart-things/(app)/ask-a-vet/attachment'
import { Route as SamsungSmartThingsappAskAVetAgreementImport } from './routes/samsung.smart-things/(app)/ask-a-vet/agreement'
import { Route as AccountsV1CompanyAppSignInImport } from './routes/accounts/v1/$company.$app.sign-in'
import { Route as SamsungSmartThingsappAskAVetSafetyMainconcernImport } from './routes/samsung.smart-things/(app)/ask-a-vet/safety.$main_concern'
import { Route as SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomImport } from './routes/samsung.smart-things/(app)/ask-a-vet/preliminary-checkup.$main_concern.$symptom'

// Create/Update Routes

const R404Route = R404Import.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRoute,
} as any)

const SamsungSmartThingsRouteRoute = SamsungSmartThingsRouteImport.update({
  id: '/samsung/smart-things',
  path: '/samsung/smart-things',
  getParentRoute: () => rootRoute,
} as any)

const SamsungSmartThingsguestRouteRoute =
  SamsungSmartThingsguestRouteImport.update({
    id: '/(guest)',
    path: '/',
    getParentRoute: () => SamsungSmartThingsRouteRoute,
  } as any)

const SamsungSmartThingsappRouteRoute = SamsungSmartThingsappRouteImport.update(
  {
    id: '/(app)',
    getParentRoute: () => SamsungSmartThingsRouteRoute,
  } as any,
)

const SamsungSmartThingsappIndexRoute = SamsungSmartThingsappIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any,
)

const SamsungSmartThingsguestLoginIndexRoute =
  SamsungSmartThingsguestLoginIndexImport.update({
    id: '/login/',
    path: '/login/',
    getParentRoute: () => SamsungSmartThingsguestRouteRoute,
  } as any)

const SamsungSmartThingsappMyConsultationsIndexRoute =
  SamsungSmartThingsappMyConsultationsIndexImport.update({
    id: '/my-consultations/',
    path: '/my-consultations/',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetIndexRoute =
  SamsungSmartThingsappAskAVetIndexImport.update({
    id: '/ask-a-vet/',
    path: '/ask-a-vet/',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingstempLoginOauth2Route =
  SamsungSmartThingstempLoginOauth2Import.update({
    id: '/(temp)/login/oauth2',
    path: '/login/oauth2',
    getParentRoute: () => SamsungSmartThingsRouteRoute,
  } as any)

const SamsungSmartThingsappConsultationIdRoute =
  SamsungSmartThingsappConsultationIdImport.update({
    id: '/consultation/$id',
    path: '/consultation/$id',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetSubmittedRoute =
  SamsungSmartThingsappAskAVetSubmittedImport.update({
    id: '/ask-a-vet/submitted',
    path: '/ask-a-vet/submitted',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetSelectPetRoute =
  SamsungSmartThingsappAskAVetSelectPetImport.update({
    id: '/ask-a-vet/select-pet',
    path: '/ask-a-vet/select-pet',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetMainConcernRoute =
  SamsungSmartThingsappAskAVetMainConcernImport.update({
    id: '/ask-a-vet/main-concern',
    path: '/ask-a-vet/main-concern',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetAttachmentRoute =
  SamsungSmartThingsappAskAVetAttachmentImport.update({
    id: '/ask-a-vet/attachment',
    path: '/ask-a-vet/attachment',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetAgreementRoute =
  SamsungSmartThingsappAskAVetAgreementImport.update({
    id: '/ask-a-vet/agreement',
    path: '/ask-a-vet/agreement',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const AccountsV1CompanyAppSignInRoute = AccountsV1CompanyAppSignInImport.update(
  {
    id: '/accounts/v1/$company/$app/sign-in',
    path: '/accounts/v1/$company/$app/sign-in',
    getParentRoute: () => rootRoute,
  } as any,
)

const SamsungSmartThingsappAskAVetSafetyMainconcernRoute =
  SamsungSmartThingsappAskAVetSafetyMainconcernImport.update({
    id: '/ask-a-vet/safety/$main_concern',
    path: '/ask-a-vet/safety/$main_concern',
    getParentRoute: () => SamsungSmartThingsappRouteRoute,
  } as any)

const SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute =
  SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomImport.update(
    {
      id: '/ask-a-vet/preliminary-checkup/$main_concern/$symptom',
      path: '/ask-a-vet/preliminary-checkup/$main_concern/$symptom',
      getParentRoute: () => SamsungSmartThingsappRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404Import
      parentRoute: typeof rootRoute
    }
    '/samsung/smart-things': {
      id: '/samsung/smart-things'
      path: '/samsung/smart-things'
      fullPath: '/samsung/smart-things'
      preLoaderRoute: typeof SamsungSmartThingsRouteImport
      parentRoute: typeof rootRoute
    }
    '/samsung/smart-things/(app)': {
      id: '/samsung/smart-things/(app)'
      path: '/'
      fullPath: '/samsung/smart-things/'
      preLoaderRoute: typeof SamsungSmartThingsappRouteImport
      parentRoute: typeof SamsungSmartThingsRouteRoute
    }
    '/samsung/smart-things/(guest)': {
      id: '/samsung/smart-things/(guest)'
      path: '/'
      fullPath: '/samsung/smart-things/'
      preLoaderRoute: typeof SamsungSmartThingsguestRouteImport
      parentRoute: typeof SamsungSmartThingsRouteImport
    }
    '/samsung/smart-things/(app)/': {
      id: '/samsung/smart-things/(app)/'
      path: '/'
      fullPath: '/samsung/smart-things/'
      preLoaderRoute: typeof SamsungSmartThingsappIndexImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/accounts/v1/$company/$app/sign-in': {
      id: '/accounts/v1/$company/$app/sign-in'
      path: '/accounts/v1/$company/$app/sign-in'
      fullPath: '/accounts/v1/$company/$app/sign-in'
      preLoaderRoute: typeof AccountsV1CompanyAppSignInImport
      parentRoute: typeof rootRoute
    }
    '/samsung/smart-things/(app)/ask-a-vet/agreement': {
      id: '/samsung/smart-things/(app)/ask-a-vet/agreement'
      path: '/ask-a-vet/agreement'
      fullPath: '/samsung/smart-things/ask-a-vet/agreement'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetAgreementImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/attachment': {
      id: '/samsung/smart-things/(app)/ask-a-vet/attachment'
      path: '/ask-a-vet/attachment'
      fullPath: '/samsung/smart-things/ask-a-vet/attachment'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetAttachmentImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/main-concern': {
      id: '/samsung/smart-things/(app)/ask-a-vet/main-concern'
      path: '/ask-a-vet/main-concern'
      fullPath: '/samsung/smart-things/ask-a-vet/main-concern'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetMainConcernImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/select-pet': {
      id: '/samsung/smart-things/(app)/ask-a-vet/select-pet'
      path: '/ask-a-vet/select-pet'
      fullPath: '/samsung/smart-things/ask-a-vet/select-pet'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetSelectPetImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/submitted': {
      id: '/samsung/smart-things/(app)/ask-a-vet/submitted'
      path: '/ask-a-vet/submitted'
      fullPath: '/samsung/smart-things/ask-a-vet/submitted'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetSubmittedImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/consultation/$id': {
      id: '/samsung/smart-things/(app)/consultation/$id'
      path: '/consultation/$id'
      fullPath: '/samsung/smart-things/consultation/$id'
      preLoaderRoute: typeof SamsungSmartThingsappConsultationIdImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(temp)/login/oauth2': {
      id: '/samsung/smart-things/(temp)/login/oauth2'
      path: '/login/oauth2'
      fullPath: '/samsung/smart-things/login/oauth2'
      preLoaderRoute: typeof SamsungSmartThingstempLoginOauth2Import
      parentRoute: typeof SamsungSmartThingsRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/': {
      id: '/samsung/smart-things/(app)/ask-a-vet/'
      path: '/ask-a-vet'
      fullPath: '/samsung/smart-things/ask-a-vet'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetIndexImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/my-consultations/': {
      id: '/samsung/smart-things/(app)/my-consultations/'
      path: '/my-consultations'
      fullPath: '/samsung/smart-things/my-consultations'
      preLoaderRoute: typeof SamsungSmartThingsappMyConsultationsIndexImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(guest)/login/': {
      id: '/samsung/smart-things/(guest)/login/'
      path: '/login'
      fullPath: '/samsung/smart-things/login'
      preLoaderRoute: typeof SamsungSmartThingsguestLoginIndexImport
      parentRoute: typeof SamsungSmartThingsguestRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern': {
      id: '/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern'
      path: '/ask-a-vet/safety/$main_concern'
      fullPath: '/samsung/smart-things/ask-a-vet/safety/$main_concern'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetSafetyMainconcernImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
    '/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom': {
      id: '/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
      path: '/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
      fullPath: '/samsung/smart-things/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
      preLoaderRoute: typeof SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomImport
      parentRoute: typeof SamsungSmartThingsappRouteImport
    }
  }
}

// Create and export the route tree

interface SamsungSmartThingsappRouteRouteChildren {
  SamsungSmartThingsappIndexRoute: typeof SamsungSmartThingsappIndexRoute
  SamsungSmartThingsappAskAVetAgreementRoute: typeof SamsungSmartThingsappAskAVetAgreementRoute
  SamsungSmartThingsappAskAVetAttachmentRoute: typeof SamsungSmartThingsappAskAVetAttachmentRoute
  SamsungSmartThingsappAskAVetMainConcernRoute: typeof SamsungSmartThingsappAskAVetMainConcernRoute
  SamsungSmartThingsappAskAVetSelectPetRoute: typeof SamsungSmartThingsappAskAVetSelectPetRoute
  SamsungSmartThingsappAskAVetSubmittedRoute: typeof SamsungSmartThingsappAskAVetSubmittedRoute
  SamsungSmartThingsappConsultationIdRoute: typeof SamsungSmartThingsappConsultationIdRoute
  SamsungSmartThingsappAskAVetIndexRoute: typeof SamsungSmartThingsappAskAVetIndexRoute
  SamsungSmartThingsappMyConsultationsIndexRoute: typeof SamsungSmartThingsappMyConsultationsIndexRoute
  SamsungSmartThingsappAskAVetSafetyMainconcernRoute: typeof SamsungSmartThingsappAskAVetSafetyMainconcernRoute
  SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute: typeof SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute
}

const SamsungSmartThingsappRouteRouteChildren: SamsungSmartThingsappRouteRouteChildren =
  {
    SamsungSmartThingsappIndexRoute: SamsungSmartThingsappIndexRoute,
    SamsungSmartThingsappAskAVetAgreementRoute:
      SamsungSmartThingsappAskAVetAgreementRoute,
    SamsungSmartThingsappAskAVetAttachmentRoute:
      SamsungSmartThingsappAskAVetAttachmentRoute,
    SamsungSmartThingsappAskAVetMainConcernRoute:
      SamsungSmartThingsappAskAVetMainConcernRoute,
    SamsungSmartThingsappAskAVetSelectPetRoute:
      SamsungSmartThingsappAskAVetSelectPetRoute,
    SamsungSmartThingsappAskAVetSubmittedRoute:
      SamsungSmartThingsappAskAVetSubmittedRoute,
    SamsungSmartThingsappConsultationIdRoute:
      SamsungSmartThingsappConsultationIdRoute,
    SamsungSmartThingsappAskAVetIndexRoute:
      SamsungSmartThingsappAskAVetIndexRoute,
    SamsungSmartThingsappMyConsultationsIndexRoute:
      SamsungSmartThingsappMyConsultationsIndexRoute,
    SamsungSmartThingsappAskAVetSafetyMainconcernRoute:
      SamsungSmartThingsappAskAVetSafetyMainconcernRoute,
    SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute:
      SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute,
  }

const SamsungSmartThingsappRouteRouteWithChildren =
  SamsungSmartThingsappRouteRoute._addFileChildren(
    SamsungSmartThingsappRouteRouteChildren,
  )

interface SamsungSmartThingsguestRouteRouteChildren {
  SamsungSmartThingsguestLoginIndexRoute: typeof SamsungSmartThingsguestLoginIndexRoute
}

const SamsungSmartThingsguestRouteRouteChildren: SamsungSmartThingsguestRouteRouteChildren =
  {
    SamsungSmartThingsguestLoginIndexRoute:
      SamsungSmartThingsguestLoginIndexRoute,
  }

const SamsungSmartThingsguestRouteRouteWithChildren =
  SamsungSmartThingsguestRouteRoute._addFileChildren(
    SamsungSmartThingsguestRouteRouteChildren,
  )

interface SamsungSmartThingsRouteRouteChildren {
  SamsungSmartThingsappRouteRoute: typeof SamsungSmartThingsappRouteRouteWithChildren
  SamsungSmartThingsguestRouteRoute: typeof SamsungSmartThingsguestRouteRouteWithChildren
  SamsungSmartThingstempLoginOauth2Route: typeof SamsungSmartThingstempLoginOauth2Route
}

const SamsungSmartThingsRouteRouteChildren: SamsungSmartThingsRouteRouteChildren =
  {
    SamsungSmartThingsappRouteRoute:
      SamsungSmartThingsappRouteRouteWithChildren,
    SamsungSmartThingsguestRouteRoute:
      SamsungSmartThingsguestRouteRouteWithChildren,
    SamsungSmartThingstempLoginOauth2Route:
      SamsungSmartThingstempLoginOauth2Route,
  }

const SamsungSmartThingsRouteRouteWithChildren =
  SamsungSmartThingsRouteRoute._addFileChildren(
    SamsungSmartThingsRouteRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/404': typeof R404Route
  '/samsung/smart-things': typeof SamsungSmartThingsRouteRouteWithChildren
  '/samsung/smart-things/': typeof SamsungSmartThingsappIndexRoute
  '/accounts/v1/$company/$app/sign-in': typeof AccountsV1CompanyAppSignInRoute
  '/samsung/smart-things/ask-a-vet/agreement': typeof SamsungSmartThingsappAskAVetAgreementRoute
  '/samsung/smart-things/ask-a-vet/attachment': typeof SamsungSmartThingsappAskAVetAttachmentRoute
  '/samsung/smart-things/ask-a-vet/main-concern': typeof SamsungSmartThingsappAskAVetMainConcernRoute
  '/samsung/smart-things/ask-a-vet/select-pet': typeof SamsungSmartThingsappAskAVetSelectPetRoute
  '/samsung/smart-things/ask-a-vet/submitted': typeof SamsungSmartThingsappAskAVetSubmittedRoute
  '/samsung/smart-things/consultation/$id': typeof SamsungSmartThingsappConsultationIdRoute
  '/samsung/smart-things/login/oauth2': typeof SamsungSmartThingstempLoginOauth2Route
  '/samsung/smart-things/ask-a-vet': typeof SamsungSmartThingsappAskAVetIndexRoute
  '/samsung/smart-things/my-consultations': typeof SamsungSmartThingsappMyConsultationsIndexRoute
  '/samsung/smart-things/login': typeof SamsungSmartThingsguestLoginIndexRoute
  '/samsung/smart-things/ask-a-vet/safety/$main_concern': typeof SamsungSmartThingsappAskAVetSafetyMainconcernRoute
  '/samsung/smart-things/ask-a-vet/preliminary-checkup/$main_concern/$symptom': typeof SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute
}

export interface FileRoutesByTo {
  '/404': typeof R404Route
  '/samsung/smart-things': typeof SamsungSmartThingsappIndexRoute
  '/accounts/v1/$company/$app/sign-in': typeof AccountsV1CompanyAppSignInRoute
  '/samsung/smart-things/ask-a-vet/agreement': typeof SamsungSmartThingsappAskAVetAgreementRoute
  '/samsung/smart-things/ask-a-vet/attachment': typeof SamsungSmartThingsappAskAVetAttachmentRoute
  '/samsung/smart-things/ask-a-vet/main-concern': typeof SamsungSmartThingsappAskAVetMainConcernRoute
  '/samsung/smart-things/ask-a-vet/select-pet': typeof SamsungSmartThingsappAskAVetSelectPetRoute
  '/samsung/smart-things/ask-a-vet/submitted': typeof SamsungSmartThingsappAskAVetSubmittedRoute
  '/samsung/smart-things/consultation/$id': typeof SamsungSmartThingsappConsultationIdRoute
  '/samsung/smart-things/login/oauth2': typeof SamsungSmartThingstempLoginOauth2Route
  '/samsung/smart-things/ask-a-vet': typeof SamsungSmartThingsappAskAVetIndexRoute
  '/samsung/smart-things/my-consultations': typeof SamsungSmartThingsappMyConsultationsIndexRoute
  '/samsung/smart-things/login': typeof SamsungSmartThingsguestLoginIndexRoute
  '/samsung/smart-things/ask-a-vet/safety/$main_concern': typeof SamsungSmartThingsappAskAVetSafetyMainconcernRoute
  '/samsung/smart-things/ask-a-vet/preliminary-checkup/$main_concern/$symptom': typeof SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/404': typeof R404Route
  '/samsung/smart-things': typeof SamsungSmartThingsRouteRouteWithChildren
  '/samsung/smart-things/(app)': typeof SamsungSmartThingsappRouteRouteWithChildren
  '/samsung/smart-things/(guest)': typeof SamsungSmartThingsguestRouteRouteWithChildren
  '/samsung/smart-things/(app)/': typeof SamsungSmartThingsappIndexRoute
  '/accounts/v1/$company/$app/sign-in': typeof AccountsV1CompanyAppSignInRoute
  '/samsung/smart-things/(app)/ask-a-vet/agreement': typeof SamsungSmartThingsappAskAVetAgreementRoute
  '/samsung/smart-things/(app)/ask-a-vet/attachment': typeof SamsungSmartThingsappAskAVetAttachmentRoute
  '/samsung/smart-things/(app)/ask-a-vet/main-concern': typeof SamsungSmartThingsappAskAVetMainConcernRoute
  '/samsung/smart-things/(app)/ask-a-vet/select-pet': typeof SamsungSmartThingsappAskAVetSelectPetRoute
  '/samsung/smart-things/(app)/ask-a-vet/submitted': typeof SamsungSmartThingsappAskAVetSubmittedRoute
  '/samsung/smart-things/(app)/consultation/$id': typeof SamsungSmartThingsappConsultationIdRoute
  '/samsung/smart-things/(temp)/login/oauth2': typeof SamsungSmartThingstempLoginOauth2Route
  '/samsung/smart-things/(app)/ask-a-vet/': typeof SamsungSmartThingsappAskAVetIndexRoute
  '/samsung/smart-things/(app)/my-consultations/': typeof SamsungSmartThingsappMyConsultationsIndexRoute
  '/samsung/smart-things/(guest)/login/': typeof SamsungSmartThingsguestLoginIndexRoute
  '/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern': typeof SamsungSmartThingsappAskAVetSafetyMainconcernRoute
  '/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom': typeof SamsungSmartThingsappAskAVetPreliminaryCheckupMainconcernSymptomRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/samsung/smart-things'
    | '/samsung/smart-things/'
    | '/accounts/v1/$company/$app/sign-in'
    | '/samsung/smart-things/ask-a-vet/agreement'
    | '/samsung/smart-things/ask-a-vet/attachment'
    | '/samsung/smart-things/ask-a-vet/main-concern'
    | '/samsung/smart-things/ask-a-vet/select-pet'
    | '/samsung/smart-things/ask-a-vet/submitted'
    | '/samsung/smart-things/consultation/$id'
    | '/samsung/smart-things/login/oauth2'
    | '/samsung/smart-things/ask-a-vet'
    | '/samsung/smart-things/my-consultations'
    | '/samsung/smart-things/login'
    | '/samsung/smart-things/ask-a-vet/safety/$main_concern'
    | '/samsung/smart-things/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/samsung/smart-things'
    | '/accounts/v1/$company/$app/sign-in'
    | '/samsung/smart-things/ask-a-vet/agreement'
    | '/samsung/smart-things/ask-a-vet/attachment'
    | '/samsung/smart-things/ask-a-vet/main-concern'
    | '/samsung/smart-things/ask-a-vet/select-pet'
    | '/samsung/smart-things/ask-a-vet/submitted'
    | '/samsung/smart-things/consultation/$id'
    | '/samsung/smart-things/login/oauth2'
    | '/samsung/smart-things/ask-a-vet'
    | '/samsung/smart-things/my-consultations'
    | '/samsung/smart-things/login'
    | '/samsung/smart-things/ask-a-vet/safety/$main_concern'
    | '/samsung/smart-things/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
  id:
    | '__root__'
    | '/404'
    | '/samsung/smart-things'
    | '/samsung/smart-things/(app)'
    | '/samsung/smart-things/(guest)'
    | '/samsung/smart-things/(app)/'
    | '/accounts/v1/$company/$app/sign-in'
    | '/samsung/smart-things/(app)/ask-a-vet/agreement'
    | '/samsung/smart-things/(app)/ask-a-vet/attachment'
    | '/samsung/smart-things/(app)/ask-a-vet/main-concern'
    | '/samsung/smart-things/(app)/ask-a-vet/select-pet'
    | '/samsung/smart-things/(app)/ask-a-vet/submitted'
    | '/samsung/smart-things/(app)/consultation/$id'
    | '/samsung/smart-things/(temp)/login/oauth2'
    | '/samsung/smart-things/(app)/ask-a-vet/'
    | '/samsung/smart-things/(app)/my-consultations/'
    | '/samsung/smart-things/(guest)/login/'
    | '/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern'
    | '/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  R404Route: typeof R404Route
  SamsungSmartThingsRouteRoute: typeof SamsungSmartThingsRouteRouteWithChildren
  AccountsV1CompanyAppSignInRoute: typeof AccountsV1CompanyAppSignInRoute
}

const rootRouteChildren: RootRouteChildren = {
  R404Route: R404Route,
  SamsungSmartThingsRouteRoute: SamsungSmartThingsRouteRouteWithChildren,
  AccountsV1CompanyAppSignInRoute: AccountsV1CompanyAppSignInRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/404",
        "/samsung/smart-things",
        "/accounts/v1/$company/$app/sign-in"
      ]
    },
    "/404": {
      "filePath": "404.tsx"
    },
    "/samsung/smart-things": {
      "filePath": "samsung.smart-things/route.tsx",
      "children": [
        "/samsung/smart-things/(app)",
        "/samsung/smart-things/(guest)",
        "/samsung/smart-things/(temp)/login/oauth2"
      ]
    },
    "/samsung/smart-things/(app)": {
      "filePath": "samsung.smart-things/(app)/route.tsx",
      "parent": "/samsung/smart-things",
      "children": [
        "/samsung/smart-things/(app)/",
        "/samsung/smart-things/(app)/ask-a-vet/agreement",
        "/samsung/smart-things/(app)/ask-a-vet/attachment",
        "/samsung/smart-things/(app)/ask-a-vet/main-concern",
        "/samsung/smart-things/(app)/ask-a-vet/select-pet",
        "/samsung/smart-things/(app)/ask-a-vet/submitted",
        "/samsung/smart-things/(app)/consultation/$id",
        "/samsung/smart-things/(app)/ask-a-vet/",
        "/samsung/smart-things/(app)/my-consultations/",
        "/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern",
        "/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom"
      ]
    },
    "/samsung/smart-things/(guest)": {
      "filePath": "samsung.smart-things/(guest)/route.tsx",
      "parent": "/samsung/smart-things",
      "children": [
        "/samsung/smart-things/(guest)/login/"
      ]
    },
    "/samsung/smart-things/(app)/": {
      "filePath": "samsung.smart-things/(app)/index.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/accounts/v1/$company/$app/sign-in": {
      "filePath": "accounts/v1/$company.$app.sign-in.tsx"
    },
    "/samsung/smart-things/(app)/ask-a-vet/agreement": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/agreement.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/attachment": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/attachment.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/main-concern": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/main-concern.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/select-pet": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/select-pet.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/submitted": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/submitted.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/consultation/$id": {
      "filePath": "samsung.smart-things/(app)/consultation/$id.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(temp)/login/oauth2": {
      "filePath": "samsung.smart-things/(temp)/login/oauth2.tsx",
      "parent": "/samsung/smart-things"
    },
    "/samsung/smart-things/(app)/ask-a-vet/": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/index.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/my-consultations/": {
      "filePath": "samsung.smart-things/(app)/my-consultations/index.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(guest)/login/": {
      "filePath": "samsung.smart-things/(guest)/login/index.tsx",
      "parent": "/samsung/smart-things/(guest)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/safety.$main_concern.tsx",
      "parent": "/samsung/smart-things/(app)"
    },
    "/samsung/smart-things/(app)/ask-a-vet/preliminary-checkup/$main_concern/$symptom": {
      "filePath": "samsung.smart-things/(app)/ask-a-vet/preliminary-checkup.$main_concern.$symptom.tsx",
      "parent": "/samsung/smart-things/(app)"
    }
  }
}
ROUTE_MANIFEST_END */
